function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { apiHelper, windowHelper as getUserDimensions } from '@appfolio/js-utils-apm';
import { Button, Icon } from '@appfolio/react-gears';
import FeedbackModal from "../components/FeedbackModal";

var FeedbackButton = /*#__PURE__*/function (_Component) {
  _inherits(FeedbackButton, _Component);

  var _super = _createSuper(FeedbackButton);

  function FeedbackButton(props) {
    var _this;

    _classCallCheck(this, FeedbackButton);

    _this = _super.call(this, props);

    _this.onSubmit = function (_ref) {
      var rating = _ref.rating,
          comment = _ref.comment;

      var _getUserDimensions = getUserDimensions(),
          browserWidth = _getUserDimensions.browserWidth,
          browserHeight = _getUserDimensions.browserHeight,
          screenWidth = _getUserDimensions.screenWidth,
          screenHeight = _getUserDimensions.screenHeight;

      var _this$props = _this.props,
          feature = _this$props.feature,
          recipient = _this$props.recipient,
          cc = _this$props.cc,
          path = _this$props.path;
      var form = {
        screen: {
          width: screenWidth,
          height: screenHeight
        },
        browser: {
          width: browserWidth,
          height: browserHeight
        },
        feedback: {
          feature: feature,
          recipient: recipient,
          cc: cc,
          rating: rating,
          comment: comment
        }
      };
      return apiHelper.post(path, form).then(function () {
        _this.hideModal();

        _this.props.onSubmit();
      }).catch(_this.hideModal);
    };

    _this.showModal = function () {
      return _this.setState({
        isOpen: true
      });
    };

    _this.hideModal = function () {
      return _this.setState({
        isOpen: false
      });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(FeedbackButton, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          recipient = _this$props2.recipient,
          cc = _this$props2.cc,
          onSubmit = _this$props2.onSubmit,
          color = _this$props2.color,
          block = _this$props2.block,
          disabled = _this$props2.disabled,
          outline = _this$props2.outline,
          size = _this$props2.size,
          children = _this$props2.children,
          className = _this$props2.className,
          backdrop = _this$props2.backdrop,
          feature = _this$props2.feature,
          modalTitle = _this$props2.modalTitle,
          otherProps = _objectWithoutProperties(_this$props2, ["recipient", "cc", "onSubmit", "color", "block", "disabled", "outline", "size", "children", "className", "backdrop", "feature", "modalTitle"]);

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        block: block,
        disabled: disabled,
        size: size,
        className: className,
        outline: outline,
        onClick: this.showModal,
        color: color
      }, children || /*#__PURE__*/React.createElement("span", {
        className: "font-weight-bold text-uppercase"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "envelope",
        className: "mr-2"
      }), "Feedback")), /*#__PURE__*/React.createElement(FeedbackModal, _extends({
        isOpen: this.state.isOpen,
        backdrop: backdrop,
        onSubmit: this.onSubmit,
        onCancel: this.hideModal,
        modalTitle: modalTitle || feature
      }, otherProps)));
    }
  }]);

  return FeedbackButton;
}(Component);

FeedbackButton.propTypes = {
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  outline: PropTypes.bool,
  size: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  feature: PropTypes.string.isRequired,
  recipient: PropTypes.string.isRequired,
  backdrop: PropTypes.bool,
  cc: PropTypes.string,
  modalTitle: PropTypes.string,
  color: PropTypes.string,
  onSubmit: PropTypes.func,
  path: PropTypes.string
};
FeedbackButton.defaultProps = {
  backdrop: false,
  color: 'primary',
  outline: true,
  path: '/feedbacks',
  onSubmit: function onSubmit() {}
};
FeedbackButton.displayName = "FeedbackButton";
export { FeedbackButton as default };